import { createdAtColumnModel } from '@features/payment/dataGrid/columns/CreatedAtColumn'

import { PaginatedBookingColumnType } from './VoucherDataGrid'
import { codeColumnModel } from './columns/codeColumn'
import { usagesColumnModel } from './columns/usagesColumn'

export const dataGridColumns: PaginatedBookingColumnType[] = [
  codeColumnModel,
  createdAtColumnModel as PaginatedBookingColumnType,
  usagesColumnModel
]
